import { faqItems } from '../../../content/healthModalsContent';
import { getStep1DataEvent } from '../../../utils/peregrine';
import uspMobile from '../widgets/Usp/uspMobile';

const birthdateField = {
  type: 'DateInput',
  props: {
    _fieldName: 'getUserInput.birthdate',
    _label: 'Geboortedatum',
    _tooltip:
      'Je leeftijd kan invloed hebben op de premie van je aanvullende verzekering',
    _containerProps: {
      width: 170,
    },
    placeholder: 'DD-MM-JJJJ',
    iconPosition: 'right',
    inputMode: 'numeric',
  },
};

const getTextGroup = (title: string, text: string, containerStyles = {}) => ({
  type: 'Div',
  props: {
    ...containerStyles,
  },
  _children: [
    {
      type: 'Heading',
      props: {
        variant: 'H3',
        as: 'h3',
        children: title,
        mt: 0,
        mb: 2,
      },
    },
    {
      type: 'P',
      props: {
        variant: 'footnoteRegular',
        color: '#727888',
        m: 0,
        children: text,
      },
    },
  ],
});

const divider = {
  type: 'Div',
  props: {
    borderTop: '1px solid',
    borderColor: 'divider',
    mt: 24,
    mb: 24,
  },
};

const getUserInput = {
  name: 'getUserInput',
  components: [
    {
      type: 'PageLayout',
      props: {
        bg: 'comparatorBG',
        header: [
          {
            type: 'PageHeader',
            props: {
              faq: {
                buttonLabel: 'Veelgestelde vragen',
                buttonIcon: 'comment',
                title: 'Veelgestelde vragen',
                items: faqItems,
                hideLabelOnMobile: true,
              },
              activeStep: 0,
            },
          },
        ],
        sideNav: [
          {
            type: 'Div',
            props: {
              position: 'sticky',
              top: '80px',
              width: '350px',
            },
            _children: [
              {
                type: 'CoverageSummaryWrapper',
                props: {
                  mb: '24px',
                  borderRadius: '24px',
                  padding: '24px !important',
                  fieldNames: [
                    'getUserInput.deductibleAmount',
                    'getUserInput.birthdate',
                    'getUserInput.hasPartner',
                    'getUserInput.postcode',
                    'getUserInput.gender',
                    'getUserInput.partnerBirthdate',
                    'getUserInput.partnerGender',
                    'getUserInput.coverageadditions',
                    'getUserInput.childBirthdate1',
                    'getUserInput.childBirthdate2',
                    'getUserInput.childBirthdate3',
                    'getUserInput.childBirthdate4',
                    'getUserInput.childBirthdate5',
                    'getUserInput.childGender1',
                    'getUserInput.childGender2',
                    'getUserInput.childGender3',
                    'getUserInput.childGender4',
                    'getUserInput.childGender5',
                  ],
                },
              },
              {
                type: 'PartnerContentManager',
                props: {
                  descriptor: {
                    type: 'Usp',
                    props: {
                      css: {
                        padding: '0 24px',
                        bg: 'transparent',
                        boxShadow: 'none',
                        svg: {
                          margin: 0,
                        },
                        div: {
                          gap: '4px',
                          marginBottom: '4px !important',
                          alignItems: 'center',
                          '> p': {
                            color: 'main.2',
                          },
                        },
                      },
                      display: ['none', null, 'block'],
                      items: [
                        'Met gratis opzegservice',
                        '14 dagen bedenktijd',
                        'Binnen 2 minuten geregeld',
                      ],
                      iconVerticalAlignment: 'start',
                    },
                  },
                },
              },
            ],
          },
        ],
        content: [
          {
            type: 'UserInputTopSectionWrapper',
            props: {
              descriptor: [
                {
                  type: 'Heading',
                  props: {
                    variant: 'H3',
                    as: 'h3',
                    children: 'Jouw gegevens',
                    fontSize: '32px !important',
                    mt: 0,
                    mb: 0,
                  },
                },
                {
                  type: 'FormDataViewer',
                  props: {
                    fieldNames: [
                      'getUserInput.postcode',
                      'getUserInput.birthdate',
                      'getUserInput.gender',
                    ],
                    formDescriptor: [
                      {
                        type: 'Div',
                        props: {
                          mt: '16px',
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                          gridGap: '16px',
                        },
                        _children: [
                          birthdateField,
                          {
                            type: 'PostcodeFieldWrapper',
                            props: {
                              _containerProps: {
                                width: 150,
                              },
                              placeholder: '1234AB',
                              _label: 'Postcode',
                              _tooltip:
                                'Je postcode kan invloed hebben op het aantal beschikbare zorgverleners',
                            },
                          },
                          {
                            type: 'TileRadioGroup',
                            props: {
                              _label: 'Geslacht',
                              name: 'gender',
                              _fieldName: 'getUserInput.gender',
                              direction: 'horizontal',
                              buttonMaxWidth: '8rem',
                              displayTilesInRow: true,
                              style: {
                                height: '54px',
                                borderRadius: '8px',
                              },
                              radios: [
                                {
                                  text: 'Man',
                                  value: 'male',
                                },
                                {
                                  text: 'Vrouw',
                                  value: 'female',
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                divider,
                { type: 'PartnerAndChildrenWrapper' },
              ],
            },
          },
          {
            type: 'Div',
            props: {
              variant: 'primaryContainer',
              borderRadius: 24,
              padding: [
                '16px',
                '16px',
                '24px 48px 32px 24px',
                '24px 48px 32px 24px',
              ],
            },
            _children: [
              getTextGroup(
                'Kies je eigen risico',
                'Kies je voor een hoger eigen risico? Dan gaat je premie omlaag.',
                { mb: 24 },
              ),
              {
                type: 'DeductibleAmount',
              },
              {
                type: 'BannerAccordion',
                props: {
                  title: 'Wat valt onder het eigen risico?',
                  text: 'Het eigen risico geldt niet voor alle zorg; een consult van de huisarts, kraamzorg en verloskundige zorg, wijkverpleging, zorg uit de aanvullende verzekering en zorg voor kinderen onder de 18 jaar worden niet met het eigen risico verrekend.',
                  variant: 'bannerSuggestion',
                  mt: 5,
                },
              },
            ],
          },
          {
            type: 'Div',
            props: {
              variant: 'primaryContainer',
              borderRadius: 24,
              padding: [
                '16px',
                '16px',
                '24px 48px 32px 24px',
                '24px 48px 32px 24px',
              ],
            },
            _children: [
              getTextGroup(
                'Kies je aanvullende dekking',
                'Kies wat voor jou van toepassing is voor het afsluiten van je zorgverzekering.',
                { mb: 24 },
              ),
              {
                type: 'CBHealthAdditionalCoverageList',
                props: {
                  _fieldName: 'getUserInput.coverageadditions',
                  fieldNames: [
                    'getUserInput.birthdate',
                    'getUserInput.postcode',
                    'getUserInput.gender',
                    'getUserInput.partnerBirthdate',
                    'getUserInput.partnerGender',
                    'getUserInput.defaultCoverages',
                    'getUserInput.activeCoverageItem',
                    'getUserInput.childBirthdate1',
                    'getUserInput.childBirthdate2',
                    'getUserInput.childBirthdate3',
                    'getUserInput.childBirthdate4',
                    'getUserInput.childBirthdate5',
                    'getUserInput.childGender1',
                    'getUserInput.childGender2',
                    'getUserInput.childGender3',
                    'getUserInput.childGender4',
                    'getUserInput.childGender5',
                  ],
                },
              },
              {
                type: 'PartnerContentManager',
                props: {
                  descriptor: [
                    divider,
                    getTextGroup(
                      'Blijf op de hoogte',
                      'Laat je e-mailadres achter dan sturen wij een persoonlijk overzicht. Niet verplicht, wel handig.',
                      { mt: 24 },
                    ),
                    {
                      type: 'Div',
                      props: {
                        mt: 6,
                        mb: 0,
                        cols: [1, 2],
                        gridColumnGap: [0, 2],
                        gridRowGap: [2, 0],
                        display: 'block',
                      },
                      _children: [
                        {
                          type: 'EmailOptional',
                          props: {
                            _fieldName: 'getUserInput.optionalemail',
                            _label: 'E-mailadres',
                            _containerProps: {
                              _tooltip: 'UNKNOWN',
                              width: ['100%', 360],
                            },
                            placeholder: 'Bijv. naam@gmail.com',
                            tooltip:
                              'Wij gebruiken je e-mailadres conform ons <a href="https://www.overstappen.nl/privacy-cookies/" target="_blank">privacy beleid</a>',
                          },
                        },
                      ],
                    },
                  ],
                },
              },
              {
                type: 'Desktop',
                _children: [
                  divider,
                  {
                    type: 'SubmitCurrentFormBtnWrapper',
                    props: {
                      text: 'Bekijk verzekeringen',
                      submitCurrentFormButtonProps: {
                        registerInPeregrineEvent: getStep1DataEvent,
                      },
                    },
                  },
                ],
              },
            ],
          },
          {
            type: 'PartnerContentManager',
            props: {
              descriptor: uspMobile,
            },
          },
          {
            type: 'MobilePriceInfo',
          },
          {
            type: 'AFMBanner',
          },
        ],
      },
    },
  ],
};

export default getUserInput;
